import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import "./Navbar.css";
import {FaTwitter, FaLeaf
} from "react-icons/fa";
import {AiFillYoutube, AiFillLinkedin} from "react-icons/ai";
import {IoMdRocket} from "react-icons/io";


const Navbar = () => {

    const [navToggle, setNavToggle] = useState(false);
    const navHandler = () => {
        setNavToggle(prevData => !prevData);
    }

  return (
    <nav className='navbar w-100 flex'>
        <div className='container w-100'>
            <div className='navbar-content flex fw-7'>
                <div className='brand-and-toggler flex flex-between w-100'>
                    <Link to = "/" className='navbar-brand fs-23'> <span><FaLeaf/></span> PAPER NETWORK</Link>
                    <div type = "button" className={`hamburger-menu ${navToggle ? 'hamburger-menu-change' : ""}`} onClick={navHandler}>
                        <div className='bar-top'></div>
                        <div className='bar-middle'></div>
                        <div className='bar-bottom'></div>
                    </div>
                </div>

                <div className={`navbar-collapse ${navToggle ? 'show-navbar-collapse' : ""}`}>
                    <div className='navbar-collapse-content'>
                        <ul className='navbar-nav'>
                            <li className='text-white'>
                                <Link to = "about" spy={true} smooth={true} offset={50} duration={500} >Features</Link>
                            </li>
                            <li className='text-white'>
                                <Link to = "/">About</Link>
                            </li>
                            <li className='text-white'>
                                <Link to = "/">FAQ's</Link>
                            </li>
                            <li className='text-white'>
                                <Link to = "/">Contacts</Link>
                            </li>
                        </ul>
                        <ul className='navbar-social flex'>
                            <li className='text-white'>
                                <a href="https://twitter.com/KhyatiKishra" target="_blank" rel='noreferrer'><FaTwitter /></a>
                            </li>
                            <li className='text-white'>
                            <a href="https://www.youtube.com" target="_blank" rel='noreferrer'><AiFillYoutube /></a>
                            </li>
                            <li className='text-white'>
                                <a href="https://www.linkedin.com/company/network-paper/" target="_blank" rel='noreferrer'><AiFillLinkedin /></a>
                            </li>
                        </ul>
                        <div className='navbar-btns'>
                            <button type = "button" className='btn'><IoMdRocket /> <span>get started</span></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </nav>
  )
}

export default Navbar